import { Component, EventEmitter, Output } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ProfileUpdateDataServiceProvider } from '@web-services/profile/profile-update.data.service';
import { ProfileUpdateServiceProvider } from '@web-services/profile/profile-update.service';
import { Subject } from 'rxjs/Subject';
import { finalize, takeUntil } from 'rxjs/operators';
import { User } from '@models/models';

@Component({
	selector: 'password-change',
	template: require('./password-change.html'),
	styles: [require('./password-change.scss')]
})
export class PasswordChangeComponent {
	@Output() onPasswordChange: EventEmitter<void> = new EventEmitter();

	password: string;
	passwordConfirm: string;
	disableButton: boolean;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private messageService: MessageService,
		private profileUpdateService: ProfileUpdateDataServiceProvider,
		private profileService: ProfileUpdateServiceProvider
	) {}

	changePassword(): void {
		if (
			this.profileService.isValidPassword(this.password, this.passwordConfirm)
		) {
			this.disableButton = true;
			this.profileUpdateService
				.changeUserPassword(this.password, this.passwordConfirm)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize(() => (this.disableButton = false))
				)
				.subscribe(
					(data: User): void => this.successChangeUserPassword(data),
					() => this.messageService.showToaster('e_0', 'general')
				);
		}
	}

	private successChangeUserPassword(data): void {
		if (data) {
			this.password = '';
			this.passwordConfirm = '';
			this.onPasswordChange.emit();
			this.messageService.showToaster('s_0', 'profile');
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/profile/password-change/password-change.ts